import { ref, Ref } from 'vue';
import { getStatusService } from '@/container/ServiceRegistration';

export interface StatusServiceComposable {
  isLoading: Ref<boolean>;
  error: Ref<string>;
  checkStatus: () => Promise<void>;
}

export function useStatusService(): StatusServiceComposable {
  const isLoading = ref(false);
  const error = ref('');

  const checkStatus = async (): Promise<void> => {
    isLoading.value = true;
    error.value = '';

    try {
      const statusService = getStatusService();
      await statusService.status();
    } catch (err: any) {
      error.value = err.message || 'Server error. Please try again later.';
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    error,
    checkStatus
  };
}
